import type { AdminOrder, CustomerInputPair } from "api/types/order.types";

/**
 * 주문한 옵션값을 "그룹: 값" 배열로 모은다.
 * - 장바구니 주문(items): 각 item 의 variant.options
 * - 단일 상품 주문: variant_info.options (이미 문자열)
 */
const collectOptionValues = (order: AdminOrder): string[] => {
  const parts: string[] = [];

  if (order.items && order.items.length > 0) {
    order.items.forEach((item) => {
      item.item_details?.variant?.options?.forEach((opt) => {
        if (opt?.value) parts.push(opt.group ? `${opt.group}: ${opt.value}` : opt.value);
      });
    });
  } else if (order.variant_info?.options) {
    parts.push(order.variant_info.options);
  }

  return parts;
};

/**
 * 사용자 입력 필드 답변(customer_input_pairs)에서 답변만 배열로 모은다.
 * 답변이 비어 있는 쌍은 제외한다.
 */
export const collectInputAnswers = (pairs?: CustomerInputPair[] | null): string[] => {
  if (!pairs || pairs.length === 0) return [];
  return pairs
    .map((p) => String(p?.answer ?? "").trim())
    .filter((answer) => answer !== "");
};

/**
 * 주문한 옵션값 + 사용자 입력 필드 답변을 한 칸에 " / " 로 구분해 표시할 문자열을 만든다.
 * 아무 값도 없으면 "-" 를 반환한다.
 */
export const formatOrderOptions = (order: AdminOrder): string => {
  const parts = [...collectOptionValues(order), ...collectInputAnswers(order.customer_input_pairs)];
  return parts.length > 0 ? parts.join(" / ") : "-";
};

/**
 * 디지털 상품 주문인지 판별한다.
 * 디지털 상품은 배송 대상이 아니라 BE 가 fulfillment_status 를 항상 None 으로 두고
 * 배송 상태 변경 요청을 INVALID_STATUS_TRANSITION 으로 거절한다.
 * product_info.is_digital 이 없으면(BE 미반영) 실물 상품으로 본다.
 */
export const isDigitalProductOrder = (order: AdminOrder): boolean =>
  order.product_info?.is_digital === true;
